// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg2DE: PageEntry = {
  id: "post.4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2",
  locale: "de",
  slug: "4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2",
  seo: {
    title: "Sozialpädagogisches Seminar auf Burg Fürsteneck | Dietz GmbH",
    description: "Sozialpädagogisches Seminar auf Burg Fürsteneck",
  },
  type: "post",
  h1: "Sozialpädagogisches Seminar auf Burg Fürsteneck",
  blocks: [
    { kind: "heading", level: 2, text: "Sozialpädagogisches Seminar auf Burg Fürsteneck" },
    { kind: "paragraph", text: "Auch in diesem Jahr nahmen unsere Auszubildenden des 2. Lehrjahres an einem Sozialpädagogischen Seminar auf Burg Fürsteneck teil. Während des Seminars lernten die Auszubildenden Präsentationstechniken kennen und durften diese auch gleich in die Praxis umsetzen und vor Publikum anwenden. Es ist uns wichtig unsere Auszubildenden auf Ihre zukünftige Tätigkeit vorzubereiten, deshalb nehmen wir auch an solch vertiefenden Schulungen und Seminaren teil." },
    { kind: "paragraph", text: "Bild v.l.n.r.: Holger Epp (Betriebsleiter), Johanna Roth, Michael Wagner (Ausbildungsleiter), Andrea Dietz (Personalleiterin), Toni Linß, Pascal Walter, Leon Knauer, Nicolas Hornbogen, Tobias Schramm, Paul Stößel, Mohamad Bozo, Bastian Lorenz." }
  ],
};
